<template>
  <div class="page-container">
    <div class="page-header">
      <h2>服务商管理</h2>
    </div>

    <div class="filter-bar">
      <el-input
        v-model="filterForm.name"
        placeholder="服务商名称"
        size="small"
        style="width: 200px;"
      />
      <el-select v-model="filterForm.status" placeholder="状态" size="small" style="width: 120px; margin-left: 10px;">
        <el-option label="全部" :value="undefined" />
        <el-option label="正常" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" size="small" style="margin-left: 10px;" @click="loadData">查询</el-button>
      <el-button type="default" size="small" style="margin-left: 10px;" @click="handleReset">重置</el-button>
      <el-button type="success" size="small" style="margin-left: 10px;" @click="showAddDialog">新增服务商</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="name" label="服务商名称" min-width="150" />
      <el-table-column prop="code" label="服务商编码" width="120" />
      <el-table-column prop="contactName" label="联系人" width="100" />
      <el-table-column prop="contactPhone" label="联系电话" width="120" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="160" align="center" />
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
          <el-button type="text" size="small" @click="viewMiniApps(scope.row)">查看小程序</el-button>
          <el-button type="text" size="small" @click="editRow(scope.row)">编辑</el-button>
          <el-button
            type="text"
            size="small"
            style="color: #F56C6C;"
            @click="deleteRow(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑服务商' : '新增服务商'" :visible.sync="showDialog" width="500px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="服务商名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入服务商名称" />
        </el-form-item>
        <el-form-item label="服务商编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入服务商编码" />
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input v-model="form.contactName" placeholder="请输入联系人姓名" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <el-input v-model="form.contactEmail" placeholder="请输入联系邮箱" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-textarea v-model="form.description" placeholder="请输入描述" rows="3" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 小程序列表弹窗 -->
    <el-dialog title="服务商下的小程序" :visible.sync="showMiniAppsDialog" width="800px">
      <el-table :data="miniApps" v-loading="miniAppsLoading" border>
        <el-table-column prop="name" label="小程序名称" />
        <el-table-column prop="code" label="小程序编码" />
        <el-table-column prop="appId" label="AppID" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" />
      </el-table>
    </el-dialog>

    <!-- 服务商详情弹窗 -->
    <el-dialog title="服务商详情" :visible.sync="showDetailDialog" width="640px">
      <el-descriptions :column="2" border size="small" v-loading="detailLoading">
        <el-descriptions-item label="服务商名称">{{ detailData.name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="服务商编码">{{ detailData.code || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detailData.status === 1 ? 'success' : 'warning'" size="mini">
            {{ detailData.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="到期时间">{{ detailData.expireAt || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ detailData.contactName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detailData.contactPhone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{ detailData.contactEmail || '-' }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ detailData.address || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照号">{{ detailData.businessLicenseNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照名称">{{ detailData.businessLicenseName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="法人">{{ detailData.legalPerson || '-' }}</el-descriptions-item>
        <el-descriptions-item label="注册地址">{{ detailData.registerAddress || '-' }}</el-descriptions-item>
        <el-descriptions-item label="描述" :span="2">{{ detailData.description || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createdAt || '-' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.updatedAt || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="showDetailDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getServiceProviderPage, getServiceProviderById, createServiceProvider, updateServiceProvider, deleteServiceProvider } from '@/api/serviceProvider'
import { getMiniAppList } from '@/api/miniApp'

export default {
  name: 'ServiceProviderList',
  data() {
    return {
      filterForm: {
        name: '',
        status: ''
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showDialog: false,
      saving: false,
      form: {
        id: null,
        name: '',
        code: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        address: '',
        description: '',
        status: 1
      },
      showMiniAppsDialog: false,
      miniApps: [],
      miniAppsLoading: false,
      currentServiceProvider: null,
      showDetailDialog: false,
      detailData: {},
      detailLoading: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getServiceProviderPage({
          page: this.page,
          pageSize: this.pageSize,
          name: this.filterForm.name || undefined,
          status: this.filterForm.status || undefined
        })
        this.list = res.data?.records || res.data?.list || []
        this.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleReset() {
      this.filterForm = {
        name: '',
        status: ''
      }
      this.loadData()
    },
    showAddDialog() {
      this.form = {
        id: null,
        name: '',
        code: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        address: '',
        description: '',
        status: 1
      }
      this.showDialog = true
    },
    editRow(row) {
      this.form = {
        id: row.id,
        name: row.name,
        code: row.code,
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        contactEmail: row.contactEmail,
        address: row.address,
        description: row.description,
        status: row.status
      }
      this.showDialog = true
    },
    async handleSave() {
      if (!this.form.name) {
        this.$message.warning('请输入服务商名称')
        return
      }
      if (!this.form.code) {
        this.$message.warning('请输入服务商编码')
        return
      }
      this.saving = true
      try {
        if (this.form.id) {
          await updateServiceProvider(this.form.id, this.form)
        } else {
          await createServiceProvider(this.form)
        }
        this.$message.success('保存成功')
        this.showDialog = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    async deleteRow(row) {
      try {
        const res = await this.$confirm('确定删除该服务商？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (res === 'confirm') {
          await deleteServiceProvider(row.id)
          this.$message.success('删除成功')
          this.loadData()
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    async viewMiniApps(row) {
      this.currentServiceProvider = row
      this.miniAppsLoading = true
      try {
        const res = await getMiniAppList({ serviceProviderId: row.id })
        this.miniApps = res.data || []
        this.showMiniAppsDialog = true
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.miniAppsLoading = false
      }
    },
    async viewDetail(row) {
      this.detailLoading = true
      this.showDetailDialog = true
      this.detailData = {}
      try {
        const res = await getServiceProviderById(row.id)
        this.detailData = res.data || {}
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.filter-bar {
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
